import { useQuery } from "@tanstack/react-query";
import httpClient from "../httpClient";
import { HttpError } from "../httpError";
import { schoolFeeStudentSearchKey } from "../../constants";
import { SchoolFeeStudentSearchResult } from "../../models/schoolFee";

const useSchoolFeeStudentSearch = ({
  coreServiceId,
  matricule,
  name,
  page,
  size,
  authorisation = "",
  enabled = true,
}: {
  coreServiceId: string;
  matricule?: string;
  name?: string;
  page?: number;
  size?: number;
  authorisation?: string;
  enabled?: boolean;
}) => {
  // A search with neither term would ask the server for every student in the
  // tenant, which is not a query the payer ever means to make.
  const hasCriteria = !!matricule || !!name;

  return useQuery<SchoolFeeStudentSearchResult, HttpError>(
    schoolFeeStudentSearchKey(coreServiceId, { matricule, name, page, size }),
    () =>
      httpClient("schoolfee/student/search", { authorisation }).get<
        SchoolFeeStudentSearchResult
      >({
        // Renamed from corporate_service_id by V74. The served contract does
        // not accept the old name.
        core_service_id: coreServiceId,
        matricule,
        name,
        page,
        size,
      }),
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: enabled && !!coreServiceId && !!authorisation && hasCriteria,
    }
  );
};

export default useSchoolFeeStudentSearch;
